import { useMemo } from "react"
import { StyledPracticeCell } from "../../../../components/Table.styled"
import { getMonths } from "../utils/helpers"

const MonthHeader = ({ fromDate, toDate }: { fromDate: string, toDate: string }) => {

  const months = useMemo(() => {
    if (fromDate && toDate) {
      return getMonths(fromDate, toDate)
    }
    return []
  }, [fromDate, toDate])

  return (
    <StyledPracticeCell>
      <div className="flex">
        {
          months?.map((month: string) => (
            <div key={month} className="month-label flex">
              <span>{month}</span>
            </div>
          ))
        }
      </div>
    </StyledPracticeCell>
  )
}

export default MonthHeader